import React, { useCallback } from "react";
import cn from "classnames";
import { useField, useFormikContext } from "formik";
import InputError from "components/InputsField/InputError";
import Label from "components/InputsField/Label";
import Input from "components/common/Input";

import styles from "./styles.module.scss";

interface FormikTextFieldProps {
  label?: string;
  format?: (value: string) => string;
  additionalComponent?: React.ReactNode;
  required?: boolean;
  wrapperClassName?: string;
  errorMode?: string;
  normalize?: (value: string) => string;
  mask?: any;
  [key: string]: any;
}

const FormikTextField: React.FC<FormikTextFieldProps> = ({
  label,
  format,
  additionalComponent,
  required,
  wrapperClassName,
  errorMode = 'center',
  normalize,
  mask,
  ...props
}) => {
    const [field, meta] = useField(props);
    const { setFieldValue, submitCount } = useFormikContext();
    const handleOnChange = useCallback(
        (e) => {
            if (!format && !normalize) {
                field.onChange(e);
            } else {
                let value = e.target.value;

                if (format) {
                    value = format(value);
                }
                if (normalize) {
                    value = normalize(value);
                }
                setFieldValue(props.name, value);
            }
        },
        [field, format, normalize, setFieldValue, props.name],
    );

    return (
      <div className={cn(styles.wrapper, wrapperClassName)}>
            {label && <Label name={props.id || props.name} label={label} required={required} />}
            <Input
                {...field}
                value={mask ? mask(field.value) : field.value}
                onChange={handleOnChange}
                isError={Boolean(meta.touched && meta.error)}
                {...props}
                id={props.id || props.name}
            />
            {additionalComponent && additionalComponent}
            {meta.touched && meta.error  && (
                <InputError message={meta.error} mode={errorMode || "top-right"} />
            )}
        </div>
    );
};

export default FormikTextField;
